import { createSelector } from 'reselect';
import find from 'ramda/es/find';
import pipe from 'ramda/es/pipe';
import values from 'ramda/es/values';

import { ACTIVE } from 'app/constants/students/statuses';

/**
* Активные ученики имеют столовую (любую)
 */

const selectIsAnybodyHasCafeteria = createSelector(
  [
    state => state.students.data,
  ],
  pipe(
    values,
    find(({ hasCafeteria, status }) => (
      // должна быть столовая
      hasCafeteria
      // а еще у ученика должен быть статус "активный"
      && status === ACTIVE
    )),
    v => !!v
  )
);

export default selectIsAnybodyHasCafeteria;
